import { HttpClient } from '@angular/common/http';
import { SettingsService } from 'src/app/services/settings.service';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ErrorStreamChange } from '../models/$error.model';
import { EventStreamChange } from '../models/$event.model';
import { JoiNotification } from "globals/store/notifications.model";
import { UserService } from "./user.service";
import { EventService} from "./event.service";
import { takeUntil } from 'rxjs/operators';
import { Router } from "@angular/router";
import { MatDialogRef } from "@angular/material/dialog";
import { LogService } from "./log.service";
import { environment } from 'src/environments/environment';
import { Store, select } from '@ngrx/store';
import { JoiEvent } from '../store/events.era';
import { JoiUser } from 'globals/store/user.data';
import { userFeature } from '../store/user.era';
import { collection, doc, Firestore, query, serverTimestamp, setDoc, where } from '@angular/fire/firestore';

@Injectable({ providedIn: 'root'})
export class NotificationsService {

    readonly api = `${environment.functionsURL}api/app`;
    public $events: Subject<EventStreamChange> = new Subject();
    public $errors: Subject<ErrorStreamChange> = new Subject();
    public $destroy: Subject<boolean> = new Subject();
    private _file = 'notifications.service.ts'
    public test = false;
    current_uid:string;
    min_notifications = 8;
    notifications:Array<JoiNotification> = [];
    old_notifications:Array<JoiNotification> = [];
    viewedNotificationsAt
    use_alert = false;
    is_loading = false;
    response_text = { accepted:'Accepted! View Event ›',declined:'Declined'}

//
    constructor(
      public userService:UserService,
      private db: Firestore,
      private router:Router,
      private http:HttpClient, 
      public store: Store
    ) {

      this.store.pipe(select(userFeature.selectLoggedIn), takeUntil(this.$destroy)).subscribe((user_loggedIn:boolean)=>{
        if(user_loggedIn){
        }
      })

    }
    makeNotification(data: Partial<JoiNotification>, event: JoiEvent) {

      // the event must be passed in since this could be called from the main dashboard / events listing
      const notification:JoiNotification = this.getDefaultNotification(event);
      for(const key in notification){
        if(data[key]) notification[key] = data[key];
      }
      if(data.permissions){
        const url = `${this.api}/make-notification`;
        return this.http.post(url, { notification, permissions:data.permissions }).subscribe(response=>{
        });
      }
    }
    updateAfterInviteResponse(type,params){
        let notifRef;
        if(type === 'events'){
            notifRef = query( collection(this.db, 'notifications'), 
                where('eventId','==',params.event.eventId),
                where('type','==','workforce'),
                where('subtype','==','invite')
            )
        }
    }
    updateNotification(id,update_obj){
        if(update_obj.action === 'add to amount'){
            // Create a reference to the SF doc.
            const DocRef = doc(this.db, "notifications", id);

// Uncomment to initialize the doc.
// sfDocRef.set({ population: 0 });

            // return this.helper.db.firestore.runTransaction(function(transaction) {
            //     // This code may get re-run multiple times if there are conflicts.
            //     return transaction.get(DocRef).then(function(Doc) {
            //         if (!Doc.exists) {
            //             throw new Error("Document does not exist!");
            //         }
            //         const newAmount = Doc.data().amount ? Doc.data().amount + 1 : 1;
            //         transaction.update(DocRef, { amount: newAmount });
            //     });
            // }).then(function() {
            //     console.log("Transaction successfully committed!");
            // }).catch(function(error) {
            //     console.log("Transaction failed: ", error);
            // });
        }
        if(update_obj.action === 'update'){
            setDoc(doc(this.db, 'notifications', id), update_obj.data, { merge: true });
        }
    }

    updateViewedNotificationsAt(){
        const update_obj: Partial<JoiUser> = {uid:this.userService.uid,viewedNotificationsAt: serverTimestamp()};
        this.viewedNotificationsAt = Date.now();
        this.userService.updateUser(update_obj, false, { file:this._file, function:'updateViewedNotificationsAt', error:new Error() })
    }

    getDefaultNotification(event: JoiEvent): JoiNotification{
        const notification: JoiNotification = {
            type: 'undefined',// task, workforce, account, notice, program
            subtype: 'undefined',// added, removed, invited, commented
            eventId: event.eventId,
            eventName: event.title,
            createdUid: this.userService.uid,
            firstName: this.userService.firstName,
            lastName: this.userService.lastName,
            photoURL: this.userService.photoURL || null,
            createdAt: serverTimestamp(),
            seen:[],
            recipients: [],
            task_name:null,
            taskId:null,
            account_name:null,
            accountId:null,
            user_type:null,
            amount:null,
            performer_name:null,
            activity_id:null,
            sample:null,
            response:null
        };
        return notification;
    }
/* 
    navigate(notification:JoiNotification, evt, dialogRef:MatDialogRef<NotificationsDialogComponent>){
        if(evt) evt.stopPropagation();
        // console.log("notification = " ,notification)
        if(notification.subtype === 'invite' && (!notification.response ||  notification.response !== 'accepted')) return;
        if(notification.subtype === 'remove') return;
        if(notification.subtype === 'added' && notification.type === 'contacts') return;
        this.is_loading = true;
        const destination = ['dashboard/'+notification.eventId];
        // todo: if (destination == location) return;
        this.router.navigate(destination);
        dialogRef.close()
        this.is_loading = false;
    }
  */
    accept(notification:JoiNotification, evt:MouseEvent){
      console.log("CAN'T ACCEPT NOTIFICATION LIKE THIS", { notification })
/*         if(evt) evt.stopPropagation();
        // console.log(" accept = " ,notification)
        notification.response = 'accepted';
        if(notification.type === 'workforce'){
            this.eventService.accept(this.eventService.events[this.eventService.event_legend[notification.eventId]]);
            notification.sample = this.response_text.accepted;
        }else if(notification.type === 'account'){
            // this.event.respondToInvite(this.event.events[this.event.event_legend[notification.eventId]], 'accept');
            notification.sample = this.response_text.accepted;
        }
        this.helper.upsert('notifications/'+notification.id,notification); */
    }

    decline(notification:JoiNotification, evt){
      console.log("CAN'T DECLINE NOTIFICATION LIKE THIS", { notification })
/*         if(evt) evt.stopPropagation();
        notification.response = 'declined';
        // console.log(" decline = " ,notification)
        if(notification.type === 'workforce'){
            this.eventService.decline(this.eventService.events[this.eventService.event_legend[notification.eventId]]);
            notification.sample = this.response_text.declined;
        }else if(notification.type === 'account'){
            // this.event.respondToInvite(this.event.events[this.event.event_legend[notification.eventId]], 'accept');
            notification.sample = this.response_text.declined;
        }
        notification.sample = ''; */
    }
}
